import { Injectable } from '@angular/core';
import { Event2EventCategoryAddRequest,Event2EventCategoryDeleteRequest,EventCategoryAddRequest,EventCategoryEditRequest,EventCategoryGetRequest } from '@dave/types';
import { Store } from '@ngrx/store';
import { EventCategoriesEntity,EventCategoriesEntityFromBackend } from '../entities/event-categories.entity';
import { Event2EventCategoriesEntity,Event2EventCategoriesEntityFromBackend } from '../entities/event-to-event-catgories.entity';
import { State } from '../State';
import { BaseActionTypes } from '../State/actions/base.actions';
import { EventCategoriesActionTypes } from '../State/actions/event-categories.actions';
import { AppGatewayService } from './app-gateway.service';

export interface CategoriesWithAssignments {
    EventCategories: EventCategoriesEntity[];
    Event2EventCategories: Event2EventCategoriesEntity[];
}

enum ErrorCodes {
    Add = 'Event Kategorien Hinzufügen fehlgeschlagen',
    Load = 'Event Kategorien Abrufen fehlgeschlagen',
    Modify = 'Event Kategorien Bearbeiten fehlgeschlagen',
    Remove = 'Event Kategorien Löschen fehlgeschlagen',
}

@Injectable({
    providedIn: 'root',
})
export class EventCategoriesDataService {
    constructor(private store$: Store<State>, private gatewayService: AppGatewayService) {}

    private pendingRequest: Promise<CategoriesWithAssignments> | null = null;

    getRequest(payload?: EventCategoryGetRequest): Promise<CategoriesWithAssignments> {
        if (this.pendingRequest) {
            return this.pendingRequest;
        }


        this.pendingRequest = this.gatewayService
            .Request({
                HistoryEventCategoryGet: payload || {},
                HistoryEvent2EventCategoryGet: {},
            })
            .then(async (res) => {
                this.pendingRequest = null;

                if (Object.keys(res?.Errors || {}).length > 0) {
                    this.store$.dispatch(
                        BaseActionTypes.ErrorAction({
                            Payload: {
                                ToasterMessage: 'EventCategories abrufen fehlgeschlagen',
                            },
                        }),
                    );
                    return null;
                }

                const result: CategoriesWithAssignments = {
                    EventCategories: res.HistoryEventCategoryGet.EventCategoriesResponse.map(EventCategoriesEntityFromBackend),
                    Event2EventCategories: res.HistoryEvent2EventCategoryGet.Event2EventCategoriesResponse.map(Event2EventCategoriesEntityFromBackend),
                };

                this.store$.dispatch(EventCategoriesActionTypes.LoadSuccess({ Payload: result }));

                return result;
            })
            .catch((err) => {
                this.pendingRequest = null;
                console.error('Error loading event categories:', err);
                this.store$.dispatch(
                    BaseActionTypes.ErrorAction({
                        Payload: {
                            ToasterMessage: ErrorCodes.Load,
                            Err: err,
                        },
                    }),
                );
                return { EventCategories: [], Event2EventCategories: [] };
            });

        return this.pendingRequest;
    }

    changeEventCategories(Payload: EventCategoryEditRequest): Promise<EventCategoriesEntity> {
        return this.gatewayService
            .Request({ HistoryEventCategoryEdit: Payload })
            .then((res) => {
                if (Object.keys(res?.Errors || {}).length === 0) {
                    const updatedCategory = EventCategoriesEntityFromBackend(res.HistoryEventCategoryEdit.EventCategoryResponse);

                    this.store$.dispatch(EventCategoriesActionTypes.UpdateSuccess({ Payload: updatedCategory }));

                    const m = EventCategoriesEntityFromBackend(res.HistoryEventCategoryEdit.EventCategoryResponse);
                    this.store$.dispatch(EventCategoriesActionTypes.CreateSuccess({ Payload: m }));
                    return m;
                } else {
                    throw res.Errors;
                }
            })
            .catch((err) => {
                this.store$.dispatch(
                    BaseActionTypes.ErrorAction({
                        Payload: {
                            ToasterMessage: 'EventCategories Bearbeiten fehlgeschlagen',
                            Err: err,
                        },
                    }),
                );
                return null;
            });
    }
    addEventCategory(Payload: EventCategoryAddRequest): Promise<EventCategoriesEntity> {
        return this.gatewayService
            .Request({ HistoryEventCategoryAdd: Payload })
            .then((res) => {
                if (Object.keys(res?.Errors || {}).length === 0) {
                    const newCategory = EventCategoriesEntityFromBackend(res.HistoryEventCategoryAdd.EventCategoryResponse);

                    this.store$.dispatch(EventCategoriesActionTypes.CreateSuccess({ Payload: newCategory }));
                    const m = EventCategoriesEntityFromBackend(res.HistoryEventCategoryAdd.EventCategoryResponse);
                    return m;
                } else {
                    throw res.Errors;
                }
            })
            .catch((err) => {
                this.store$.dispatch(
                    BaseActionTypes.ErrorAction({
                        Payload: {
                            ToasterMessage: 'EventCategories Hinzufügen fehlgeschlagen',
                            Err: err,
                        },
                    }),
                );
                return null;
            });
    }

    addEvent2EventCategory(Payload: Event2EventCategoryAddRequest): Promise<Event2EventCategoriesEntity> {
        return this.gatewayService
            .Request({ HistoryEvent2EventCategoryAdd: Payload })
            .then((res) => {
                if (Object.keys(res?.Errors || {}).length === 0) {
                    const newCategory = Event2EventCategoriesEntityFromBackend(res.HistoryEvent2EventCategoryAdd.Event2EventCategoriesResponse);
                    console.log('Dispatching CreateSuccessE2EC:', newCategory);
                    this.store$.dispatch(EventCategoriesActionTypes.CreateSuccessE2EC({ Payload: newCategory }));

                    return newCategory;
                } else {
                    throw res.Errors;
                }
            })
            .catch((err) => {
                this.store$.dispatch(
                    BaseActionTypes.ErrorAction({
                        Payload: {
                            ToasterMessage: 'Event Kategorie zuweisung Hinzufügen fehlgeschlagen',
                            Err: err,
                        },
                    }),
                );
                return null;
            });
    }

    deleteEvent2EventCategory(Payload: Event2EventCategoryDeleteRequest): Promise<boolean> {
        return this.gatewayService
            .Request({ HistoryEvent2EventCategoryDelete: Payload })
            .then((res) => {
                if (Object.keys(res?.Errors || {}).length === 0) {
                    this.store$.dispatch(EventCategoriesActionTypes.DeleteSuccessE2EC({ Payload: Payload.Id }));
                    return true;
                } else {
                    throw res.Errors;
                }
            })
            .catch((err) => {
                this.store$.dispatch(
                    BaseActionTypes.ErrorAction({
                        Payload: {
                            ToasterMessage: 'Event Kategorie zuweisung löschen fehlgeschlagen',
                            Err: err,
                        },
                    }),
                );
                return null;
            });
    }

    deleteEventCategory(Payload: Event2EventCategoryDeleteRequest): Promise<boolean> {
        return this.gatewayService
            .Request({ HistoryEventCategoryDelete: Payload })
            .then((res) => {
                if (Object.keys(res?.Errors || {}).length === 0) {
                    this.store$.dispatch(EventCategoriesActionTypes.DeleteSuccess({ Payload: Payload.Id }));
                    return true;
                } else {
                    throw res.Errors;
                }
            })
            .catch((err) => {
                this.store$.dispatch(
                    BaseActionTypes.ErrorAction({
                        Payload: {
                            ToasterMessage: 'Event Kategorie löschen fehlgeschlagen',
                            Err: err,
                        },
                    }),
                );
                return null;
            });
    }
}
